import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import HandbookCart from "../handbookcart/HandbookCart";
import images from "../../../../../../../../utilities/images/images";
import { ReactComponent as BackArrowIcon } from "../../../../../../../../utilities/images/study_dashboard/back_to_learning_arrow.svg";
import { goBackFromHandbookPage } from "../../../../../../../../custom_utilities/dashboardBannerNavigation";
import "./CartHeader.scss";

const CartHeader = ({ exploreMotion = false }) => {
  const history = useHistory();
  const location = useLocation();

  const goBack = () => {
    goBackFromHandbookPage(history, location);
  };

  return (
    <div
      className={`back_btn_and_cart${
        exploreMotion ? " back_btn_and_cart--explore-motion" : ""
      }`}
    >
      <div className="back_btn_and_cart_inner">
        {exploreMotion ? (
          <button
            type="button"
            className="cart-header-back cart-header-back--explore"
            onClick={goBack}
          >
            <BackArrowIcon className="cart-header-back__icon" aria-hidden="true" />
            <span>Back</span>
          </button>
        ) : (
          <div className="cart-header-back" onClick={goBack}>
            <img src={images.storeBck} alt="back" />
            Back
          </div>
        )}

        <HandbookCart />
      </div>
    </div>
  );
};

export default CartHeader;
